import { z } from 'zod';
import { OptimizationTechnique } from '@/service/one-click-deploy/type';

export const formSchemaCreate = z.object({
  huggingFace: z.object({
    link: z.string().min(1),
    token: z.string().optional(),
  }),
  instanceName: z.string().min(1).max(50),
  instance: z.object({
    region: z.string(),
    provider: z.string(),
    gpu: z.string(),
    // number: z.number(),
    optimizationTechnique: z.nativeEnum(OptimizationTechnique),
  }),
  model: z
    .object({
      modelName: z.string().optional(),
      minVRamRequiredGB: z.number().optional(),
      architecture: z.string().optional(),
    })
    .optional(),
});

export type FormSchemaCreate = z.infer<typeof formSchemaCreate>;
